import { createAPIService } from './api.service';

export const MAIN_ENDPOINT = '/contact/api/v1/contacts';

const service = createAPIService(MAIN_ENDPOINT);

service.getContact = async id => (await service.get(`/${id}`)).data;

service.getContactByReferenceId = async referenceId =>
  (await service.get(`/references?referenceId=${referenceId}`)).data;

service.createContact = async contact => (await service.post('', contact)).data;

service.updateContact = async (id, contact) =>
  (await service.patch(`/${id}`, contact)).data;

service.deleteContact = async id => (await service.delete(`/${id}`)).data;

service.performContactOperations = async (id, params) =>
  (await service.post(`/${id}/operations`, null, { params })).data;

service.fetchContactsReferences = async params =>
  (await service.get(`/references`, { params })).data;

export default service;
